import { TicketTypeEnum } from "../_common/enum/ticketType.enum";
import { API_URL } from "../_config/config.const";
import { getBody } from "../_helpers/body.helper";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";
import { getQuery } from "../_helpers/query.helper";

const API_NAME = "ticket";

export const ticketService = {
    getAll,
    getAllTicketsView,
    get,
    submit(model?: any, ticketType?: string) { return model?.id ? put(model, ticketType) : post(model, ticketType) },
    disable
};

function getAll(query: any) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetAll?${getQuery(query)}`, requestOptions).then(handleResponse);
}

function getAllTicketsView(query: any) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetAllTicketsView?${getQuery(query)}`, requestOptions).then(handleResponse);
}

function get(id: string, ticketType?: string) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME + ticketType}/Get/?id=${id}`, requestOptions).then(handleResponse);
}

function post(model: any, ticketType?: string) {
    const requestOptions = { method: 'POST', headers: getHeader(), body: getBody(model) };
    return fetch(`${API_URL}/${API_NAME + ticketType}/create`, requestOptions).then(handleResponse);
}

function put(model: any, ticketType?: string) {
    const requestOptions = { method: 'PUT', headers: getHeader(), body: getBody(model) };
    return fetch(`${API_URL}/${API_NAME + ticketType}/update`, requestOptions).then(handleResponse);
}

function disable(id: any, ticketType?: string) {
    const requestOptions = { method: 'DELETE', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME + ticketType}/disable/?id=${id}`, requestOptions).then(handleResponse);
}


